// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7d140dc5","879":"a25d073d"}[chunkId] + ".chunk.js";
};